export default class StickyMenu {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        let desktopMenuToggle = document.querySelector('#ast-desktop-header .menu-close');
        let desktopMenu = document.querySelector('.ast-desktop-header-content');
        let astDesktopMenuToggle = document.querySelector('#ast-desktop-header .main-header-menu-toggle');

        if (desktopMenuToggle) {
            desktopMenuToggle.onclick = () => {
                document.body.classList.remove('ast-main-header-nav-open');
                desktopMenu.style.display = 'none';
                astDesktopMenuToggle.classList.remove('toggled');
            }
        }

        let mobileMenuToggle = document.querySelector('#ast-mobile-header .menu-close');
        let mobileMenu = document.querySelector('#ast-mobile-header .ast-mobile-header-content');
        let astMobileMenuToggle = document.querySelector('#ast-mobile-header .main-header-menu-toggle');

        if (astMobileMenuToggle) {
            astMobileMenuToggle.onclick = () => {
                document.body.classList.add('ast-main-header-nav-open');
                mobileMenu.style.display = 'block';
                astMobileMenuToggle.classList.add('toggled');
            }
        }

        if (mobileMenuToggle) {
            mobileMenuToggle.onclick = () => {
                document.body.classList.remove('ast-main-header-nav-open');
                mobileMenu.style.display = 'none';
                astMobileMenuToggle.classList.remove('toggled');
            }
        }

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape' && document.body.classList.contains('ast-main-header-nav-open')) {
                document.body.classList.remove('ast-main-header-nav-open');
                desktopMenu.style.display = 'none';
                mobileMenu.style.display = 'none';
                astDesktopMenuToggle.classList.remove('toggled');
            }
        });

        document.body.addEventListener("click", function (event) {
            if (!event.target.closest('.menu-toggle') && !event.target.closest('.ast-desktop-header-content') && !event.target.closest('.ast-mobile-header-content')) {
                document.body.classList.remove('ast-main-header-nav-open');
                desktopMenu.style.display = 'none';
                mobileMenu.style.display = 'none';
                astDesktopMenuToggle.classList.remove('toggled');
                astMobileMenuToggle.classList.remove('toggled');
            }
        });
    }
}